import { render, staticRenderFns } from "./tencenttargetings-add-or-update.vue?vue&type=template&id=dc8bf8f6&"
import script from "./tencenttargetings-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tencenttargetings-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports